module.exports = __webpack_public_path__ + "media/evolve/assets/icons/atlas/close-9d4da0020e660a86ec241e215a212fbb.svg";